import { INVALID_ORG_CODES } from '$lib/utils/general'
import type { ParamMatcher } from '@sveltejs/kit'

export const match: ParamMatcher = (param) => {
  if (!/^([\da-z-]{2,})$/i.test(param)) return false
  return !INVALID_ORG_CODES.includes(param)
}
